export interface BalanceExceededDetails {
  leaveTypeName?: string;
  currentBalance: number;
  balanceAfter: number;
  negativeMax: number;
  amount: number;
}

export interface BalanceOverrideInput {
  allowNegativeBalance: true;
  balanceOverrideReason: string;
}

export type BalanceOverridePrompt = (
  details: BalanceExceededDetails,
) => Promise<string | null>;

export class LeaveBalanceExceededError extends Error {
  readonly details: BalanceExceededDetails;

  constructor(message: string, details: BalanceExceededDetails) {
    super(message);
    this.name = "LeaveBalanceExceededError";
    this.details = details;
  }
}

export class BalanceOverrideDeclined extends Error {
  constructor() {
    super("Bakiye aşımı onaylanmadı");
    this.name = "BalanceOverrideDeclined";
  }
}

export function leaveBalanceExceededFrom(
  body: unknown,
): LeaveBalanceExceededError | null {
  if (typeof body !== "object" || body === null) return null;
  const response = body as Record<string, unknown>;
  if (response.code !== "LEAVE_BALANCE_EXCEEDED") return null;
  return new LeaveBalanceExceededError(
    typeof response.message === "string"
      ? response.message
      : "Bakiye limiti aşılıyor",
    {
      leaveTypeName:
        typeof response.leaveTypeName === "string"
          ? response.leaveTypeName
          : undefined,
      currentBalance: Number(response.currentBalance),
      balanceAfter: Number(response.balanceAfter),
      negativeMax: Number(response.negativeMax),
      amount: Number(response.amount),
    },
  );
}

export async function withBalanceOverride<T>(
  run: (override?: BalanceOverrideInput) => Promise<T>,
  prompt: BalanceOverridePrompt,
): Promise<T> {
  try {
    return await run();
  } catch (error) {
    if (!(error instanceof LeaveBalanceExceededError)) throw error;
    const reason = await prompt(error.details);
    if (!reason) throw new BalanceOverrideDeclined();
    return run({ allowNegativeBalance: true, balanceOverrideReason: reason });
  }
}
